import React from 'react'
import type { Icon } from 'shared/utils'

const KingDeal = (props: Icon) => {
    const { color = 'black', size = 24, className = 'king-deal' } = props
    return (
        <svg className={className} width={size} height={size} fill={color}>
            <path
                fillRule="evenodd"
                d="M19.514 6.078L21 3.188C16.018.577 9.815 2.411 7.145 7.28a9.595 9.595 0 0 0-.83 2.02H4.037L3 11.318h2.957a9.709 9.709 0 0 0-.004 1.34H4.037L3 14.675h3.303c1.517 5.318 7.154 8.435 12.602 6.957A10.697 10.697 0 0 0 21 20.814l-1.486-2.894c-.2.107-.404.204-.609.292-3.512 1.476-7.583-.105-9.098-3.536h5.28l1.038-2.019H9.278a6.39 6.39 0 0 1 0-1.339h7.537L17.852 9.3H9.82a6.4 6.4 0 0 1 .287-.564c1.846-3.274 6.056-4.462 9.408-2.658z"
            />
        </svg>
    )
}

export { KingDeal }
